import { IAmendmentPagedRequest } from '../../../../model/sge/amendment/request/amendment-paged-request';

// Filtros que ficam no painel "Mais filtros" (a busca textual fica sempre visível)
const EXTRA_FILTER_KEYS: Array<keyof IAmendmentPagedRequest> = [
    'year', 'status', 'type', 'parlamentarId', 'politicalPartyId', 'minValue', 'maxValue',
    'startDate', 'endDate', 'budgetUnitId', 'budgetProgramId', 'budgetActionId',
];

export function countActiveExtraFilters(parameters: IAmendmentPagedRequest): number {
    return EXTRA_FILTER_KEYS.filter((key) => parameters[key] !== undefined && parameters[key] !== null && parameters[key] !== '').length;
}

export const EMPTY_AMENDMENT_FILTERS: Partial<IAmendmentPagedRequest> = Object.fromEntries(
    [...EXTRA_FILTER_KEYS, 'search'].map((key) => [key, undefined])
);
